module.exports = __webpack_public_path__ + "static/media/ukas-logo.b22b0b18.jpg";